import { render, staticRenderFns } from "./StudyDealItem.vue?vue&type=template&id=861f7b96&scoped=true&"
import script from "./StudyDealItem.vue?vue&type=script&lang=js&"
export * from "./StudyDealItem.vue?vue&type=script&lang=js&"
import style0 from "./StudyDealItem.vue?vue&type=style&index=0&id=861f7b96&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "861f7b96",
  null
  
)

export default component.exports